import { useCallback } from 'react';
import { GridApi } from 'ag-grid-community';

export const useFocusCell = (gridApi: GridApi | null) => {
  return useCallback(
    (row: number, column: number) => {
      if (!gridApi) return;
      const columns = gridApi.getAllDisplayedColumns();
      const columnModel = columns?.[column];
      if (!columnModel) return;
      gridApi.ensureIndexVisible(row);
      gridApi.ensureColumnVisible(columnModel);
      gridApi.setFocusedCell(row, columnModel);
    },
    [gridApi],
  );
};
